export const scrollTo = (id) => {
  if (!id) return;
  const element = document.getElementById(id);
  if (!element) return;
  element.scrollIntoView({
    behavior: "smooth",
  });
};
